// Mock data for NPCMOP website. Multilingual fields use { en, es } objects.
// Brand names (NPCMOP, Messengers of Peace, Holy Fire, Pre Camp Rally, NPCMOP) intentionally kept in English in both languages.

export const siteConfig = {
  name: "NPCMOP",
  fullName: "Northern Pacific District - Messengers of Peace",
  tagline: "A Generation on Fire for God",
  mission: "Empowering young believers to spread peace, share the gospel, and transform communities across the Northern Pacific District.",
  email: "npcdmop@gmail.com",
  phone: "",
  address: { en: "Bay Area, CA", es: "Área de la Bahía, CA" }
};

export const socialLinks = {
  instagram: "https://www.instagram.com/npcmop/",
  facebook: "https://www.facebook.com/northernpacificoast.mop",
  youtube: "https://www.youtube.com/channel/UC_SPOw8tOYlNpF3AXmdMAjw/featured",
  spotify: "https://open.spotify.com/show/npcmop",
  applePodcast: "https://podcasts.apple.com/npcmop"
};

export const googleForms = {
  ministryApplication: "https://docs.google.com/forms/d/e/1FAIpQLSeaRnZX2MQ-16h6WaZreFYR6j00TWPjFVsX4ZGG-yZ1bNb3Kg/viewform",
  contactForm: "",
  eventRegistration: "",
  testimonySubmission: ""
};

export const eventLinks = {
  missionsSalinas: "https://brushfire.com/npcdmop/Missionsalinas2026/625294/details",
  highSchoolCamp: "https://brushfire.com/npcdmop/2026npcdhsyouthcamp/626290",
  collegeCareerCamp: "https://brushfire.com/npcdmop/2026npcdccyouthcamp/616339"
};

export const leaders = [
  {
    id: 1,
    name: "Steven Facio",
    role: { en: "President", es: "Presidente" },
    image: "/images/leader-steven.jpg",
    bio: { en: "", es: "" }
  },
  {
    id: 2,
    name: "Ruben Orona",
    role: { en: "Vice President", es: "Vicepresidente" },
    image: "/images/leader-ruben.jpg",
    bio: { en: "", es: "" }
  },
  {
    id: 3,
    name: "Danielle Oceguera",
    role: { en: "Secretary", es: "Secretaria" },
    image: "/images/leader-danielle.jpg",
    bio: { en: "", es: "" }
  },
  {
    id: 4,
    name: "Walter Manuofetoa",
    role: { en: "Treasurer", es: "Tesorero" },
    image: "/images/leader-walter.jpg",
    bio: { en: "", es: "" }
  }
];

export const upcomingEvents = [
  {
    id: 5,
    title: { en: "High School Camp", es: "Campamento de Secundaria" },
    date: "2026-08-21",
    time: { en: "August 21-23 (3 Days)", es: "21-23 de Agosto (3 Días)" },
    location: "Mt. Hermon Ponderosa Camp Grounds",
    description: {
      en: "Three days of adventure, worship, and spiritual growth at the beautiful Mt. Hermon. High school students will experience life-changing moments.",
      es: "Tres días de aventura, adoración y crecimiento espiritual en el hermoso Mt. Hermon. Los estudiantes de secundaria vivirán momentos que les cambiarán la vida."
    },
    image: "/images/moments-camp.jpg",
    featured: true,
    category: { en: "Retreat", es: "Retiro" },
    registrationOpen: true,
    registrationLinks: {
      counselor: "https://brushfire.com/npcdmop/2026npcdhsyouthcamp/626290",
      student: "https://brushfire.com/npcdmop/2026npcdhsyouthcamp/625177"
    }
  },
  {
    id: 6,
    title: { en: "College and Career Camp", es: "Campamento Universitario y Profesional" },
    date: "2026-09-18",
    time: { en: "September 18-20 (3 Days)", es: "18-20 de Septiembre (3 Días)" },
    location: "Mt. Hermon Ponderosa Camp Grounds",
    description: {
      en: "A weekend retreat designed for college students and young professionals. Worship, teaching, and fellowship focused on navigating faith in this season of life.",
      es: "Un retiro de fin de semana diseñado para estudiantes universitarios y jóvenes profesionales. Adoración, enseñanza y comunión enfocados en vivir la fe en esta etapa de la vida."
    },
    image: "/images/event-cc.jpg",
    featured: true,
    category: { en: "Retreat", es: "Retiro" },
    registrationOpen: true,
    registrationLink: "https://brushfire.com/npcdmop/2026npcdccyouthcamp/616339"
  }
];

export const coreValues = [
  {
    id: 1,
    title: { en: "Serving Down", es: "Servir hacia Abajo" },
    description: { en: "Servant leadership and humility", es: "Liderazgo servicial y humildad" },
    icon: "HeartHandshake"
  },
  {
    id: 2,
    title: { en: "Compassion", es: "Compasión" },
    description: {
      en: "We operate through love and people should feel it",
      es: "Operamos a través del amor y la gente debe sentirlo"
    },
    icon: "Heart"
  },
  {
    id: 3,
    title: { en: "Discipleship", es: "Discipulado" },
    description: {
      en: "Training up the next generation of leaders",
      es: "Formando a la próxima generación de líderes"
    },
    icon: "Users"
  },
  {
    id: 4,
    title: { en: "Thinking Small", es: "Pensar en los Detalles" },
    description: { en: "Caring about the details", es: "Cuidar los detalles" },
    icon: "Focus"
  },
  {
    id: 5,
    title: { en: "FUN", es: "DIVERSIÓN" },
    description: { en: "Church shouldn't be boring", es: "La iglesia no debería ser aburrida" },
    icon: "Smile"
  },
  {
    id: 6,
    title: { en: "Passion", es: "Pasión" },
    description: {
      en: "We care deeply about the work and vision",
      es: "Nos importa profundamente la obra y la visión"
    },
    icon: "Flame"
  },
  {
    id: 7,
    title: { en: "Generosity", es: "Generosidad" },
    description: { en: "Giving more than expected", es: "Dar más de lo esperado" },
    icon: "Gift"
  },
  {
    id: 8,
    title: { en: "Honor", es: "Honra" },
    description: {
      en: "Seeing and serving people how God does",
      es: "Ver y servir a las personas como Dios lo hace"
    },
    icon: "Crown"
  }
];

export const donationInfo = {
  venmo: {
    handle: "@NPCMOP",
    link: "https://account.venmo.com/u/NPCMOP",
    qrCode: ""
  },
  zelle: {
    email: "npcdyouthtreasure@gmail.com"
  },
  funds: [
    { en: "General Fund", es: "Fondo General" },
    { en: "Missions Salinas", es: "Missions Salinas" },
    { en: "Youth & Camps", es: "Jóvenes y Campamentos" },
    { en: "AV & Production", es: "AV y Producción" }
  ]
};

export const ministries = [
  {
    id: 1,
    name: { en: "Worship Team", es: "Equipo de Adoración" },
    icon: "Music",
    description: {
      en: "Use your musical gifts to lead others into God's presence. Singers, instrumentalists, and tech crew welcome.",
      es: "Usa tus dones musicales para llevar a otros a la presencia de Dios. Cantantes, instrumentistas y equipo técnico bienvenidos."
    }
  },
  {
    id: 2,
    name: { en: "Media Team", es: "Equipo de Medios" },
    icon: "Video",
    description: {
      en: "Create compelling content, run live production, and help spread the message through digital platforms.",
      es: "Crea contenido impactante, produce eventos en vivo y ayuda a difundir el mensaje a través de plataformas digitales."
    }
  },
  {
    id: 3,
    name: { en: "Outreach & Missions", es: "Alcance y Misiones" },
    icon: "Heart",
    description: {
      en: "Make a tangible difference in your community and beyond through service, evangelism, and mission trips.",
      es: "Marca una diferencia tangible en tu comunidad y más allá a través del servicio, evangelismo y viajes misioneros."
    }
  },
  {
    id: 4,
    name: { en: "Leadership Development", es: "Desarrollo de Liderazgo" },
    icon: "Users",
    description: {
      en: "Grow as a leader through mentorship, training, and hands-on ministry experience.",
      es: "Crece como líder a través de mentoría, capacitación y experiencia ministerial práctica."
    }
  },
  {
    id: 5,
    name: { en: "Prayer Team", es: "Equipo de Oración" },
    icon: "HeartHandshake",
    description: {
      en: "Intercede for the district, events, and individuals. Be the foundation of everything we do.",
      es: "Intercede por el distrito, los eventos y las personas. Sé el fundamento de todo lo que hacemos."
    }
  },
  {
    id: 6,
    name: { en: "Creative Arts", es: "Artes Creativas" },
    icon: "Palette",
    description: {
      en: "Express your faith through dance, drama, visual arts, and creative expression.",
      es: "Expresa tu fe a través de la danza, el drama, las artes visuales y la expresión creativa."
    }
  }
];

export const aboutContent = {
  vision: {
    en: "To raise up a generation of young believers who are on fire for God, equipped to spread peace, share the gospel, and transform their communities and the world.",
    es: "Levantar una generación de jóvenes creyentes encendidos por Dios, equipados para difundir paz, compartir el evangelio y transformar sus comunidades y el mundo."
  },
  mission: {
    en: "We exist to empower youth across the Northern Pacific District through dynamic worship, practical discipleship, authentic community, and impactful service opportunities.",
    es: "Existimos para empoderar a los jóvenes en todo el Distrito del Pacífico Norte a través de adoración dinámica, discipulado práctico, comunidad auténtica y oportunidades de servicio con impacto."
  },
  scripture: {
    en: "A fire shall always be burning on the altar; it shall never go out. - Leviticus 6:13",
    es: "El fuego arderá continuamente en el altar; no se apagará. - Levítico 6:13"
  }
};
